module.exports = __webpack_public_path__ + "static/media/susantmallick.a8e0453a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/susantmallick.webp
// module id = 364
// module chunks = 0